import Vue from 'vue'
import Vuex from 'vuex'
import app from '@store/modules/app'
import form from '@store/modules/form'
import i18n from '@store/modules/i18n'
import lang from '@store/modules/lang'
import booking from '@store/modules/booking'

Vue.use(Vuex);


export default new Vuex.Store({
  state: {},
  mutations: {},
  modules: {
    app,
    form,
    i18n,
    lang,
    booking,
  },
  //strict: process.env.NODE_ENV !== 'production',
  strict: false,
});